import md5 from 'js-md5' //引入MD5加密
import axios from 'axios'
import yxz_config from '../common/config/config.js';
import {
  concurrentExecution
} from '../src/utils/jnxh.js'
import {
  getStore
} from '../src/utils/storage.js'

/**
 * 文件分片上传
 * @params file {File} 文件
 * @params data {data} 携带参数
 * @params pieceSize {Number} 分片大小 默认3MB
 * @params concurrent {Number} 并发数量 默认2
 * @params process {Function} 进度回调函数
 * @params success {Function} 成功回调函数
 * @params error {Function} 失败回调函数
 */
export const uploadByPieces = ({
  file,
  data,
  pieceSize = 3,
  concurrent = 3,
  success,
  process,
  error
}) => {
  // 如果文件传入为空直接 return 返回
  if (!file || file.length < 1) {
    return error('文件不能为空')
  }
  let fileMD5 = '' // 总文件列表
  const chunkSize = pieceSize * 1024 * 1024 // 1MB一片
  const chunkCount = Math.ceil(file.size / chunkSize) // 总片数
  const chunkList = [] // 分片列表
  let uploaded = [] // 已经上传的
  let fileType = '' // 文件类型
  const objectType = data.objectType // 上传业务类型
  const objectTag = data.objectTag // 上传业务返回标记
  let uploadId = '' // 上传id

  /***
   * 获取md5
   **/
  const readFileMD5 = () => {

    fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length)
    let fileRederInstance = new FileReader()
    fileRederInstance.readAsBinaryString(file)
    fileRederInstance.addEventListener('load', e => {
      let fileBolb = e.target.result
      fileMD5 = md5(fileBolb)
      let form = new FormData()
      form.append('fileName', file.name)
      form.append('identifier', fileMD5)
      form.append('fileType', fileType)
      form.append('objectType', objectType)
      form.append('objectTag', objectTag)
      form.append('chunkNumber', 1)
      form.append('uploadId', uploadId)
      uploadPost(form).then(res => {
        if (res.data.skipUpload) {
          yxz_config.debug?console.log('文件已被上传'):''
          success && success(res)
        } else {
          uploadId = res.data.uploadId
          // 判断是否是断点续传
          if (res.data.uploaded && res.data.uploaded.length != 0) {
            uploaded = [].concat(res.data.uploaded)
          }

          yxz_config.debug?console.log('已上传的分片：' + uploaded):''

          // 判断是并发上传或顺序上传
          if (concurrent == 1 || chunkCount == 1) {
            sequentialUplode(0)
          } else {
            concurrentUpload()
          }
        }
      }).catch((e) => {
        console.log('文件合并错误')
        console.log(e)

      })
    })
  }

  /***
   * 获取每一个分片的详情
   **/
  const getChunkInfo = (file, currentChunk, chunkSize) => {
    let start = currentChunk * chunkSize
    let end = Math.min(file.size, start + chunkSize)
    let chunk = file.slice(start, end)
    return {
      start,
      end,
      chunk
    }
  }

  /***
   * 针对每个文件进行chunk处理
   **/
  const readChunkMD5 = () => {
    // 针对单个文件进行chunk上传
    for (var i = 0; i < chunkCount; i++) {
      const {
        chunk
      } = getChunkInfo(file, i, chunkSize)

      // 判断已经上传的分片中是否包含当前分片
      if (uploaded.indexOf(i + '') == -1) {
        uploadChunk({
          chunk,
          currentChunk: i,
          chunkCount
        })
      }
    }
  }

  /***
   * 原始上传
   **/
  const uploadChunk = (chunkInfo) => {
    var sd = parseInt((chunkInfo.currentChunk / chunkInfo.chunkCount) * 100)
    yxz_config.debug?console.log(sd, '进度'):''
    process(sd)
    yxz_config.debug?console.log(chunkInfo, '分片大小'):''
    let inde = chunkInfo.currentChunk + 1
    if (uploaded.indexOf(inde + '') > -1) {
      const {
        chunk
      } = getChunkInfo(file, chunkInfo.currentChunk + 1, chunkSize)
      uploadChunk({
        chunk,
        currentChunk: inde,
        chunkCount
      })
    } else {
      let uploadData = createUploadData(chunkInfo)
      // 执行分片上传
      uploadPost(uploadData).then(res => {
        if (res.code == 200) {
          yxz_config.debug?console.log('分片上传成功'):''
          uploaded.push(chunkInfo.currentChunk + 1)
          // 判断是否全部上传完
          if (uploaded.length == chunkInfo.chunkCount) {
            yxz_config.debug?console.log('全部完成'):''
            success(res)
            process(100)
          } else {
            const {
              chunk
            } = getChunkInfo(file, chunkInfo.currentChunk + 1, chunkSize)
            uploadChunk({
              chunk,
              currentChunk: chunkInfo.currentChunk + 1,
              chunkCount
            })
          }

        } else {
          console.log('res.msg',res.msg)
        }
      }).catch((e) => {
        error && error(e)
      })
      // if (chunkInfo.currentChunk < chunkInfo.chunkCount) {
      //   setTimeout(() => {
      //
      //   }, 1000)
      // }
    }
  }

  /***
   * 顺序上传
   **/
  const sequentialUplode = (currentChunk) => {
    const {
      chunk
    } = getChunkInfo(file, currentChunk, chunkSize)
    let chunkInfo = {
      chunk,
      currentChunk,
      chunkCount,
      uploadId
    }
    var sd = parseInt((chunkInfo.currentChunk / chunkInfo.chunkCount) * 100)
    process(sd)
    yxz_config.debug?console.log('当前上传分片：' + currentChunk):""
    let inde = chunkInfo.currentChunk + 1
    if (uploaded.indexOf(inde + '') > -1) {
      yxz_config.debug?console.log('分片【' + currentChunk + '】已上传'):""
      sequentialUplode(currentChunk + 1)
    } else {
      let uploadData = createUploadData(chunkInfo)
      // 执行分片上传
      uploadPost(uploadData).then(res => {
        if (res.code == 200) {
          yxz_config.debug?console.log('分片【' + currentChunk + '】上传成功'):""
          uploaded.push(chunkInfo.currentChunk + 1)
          // 判断是否全部上传完
          if (uploaded.length == chunkInfo.chunkCount) {
            yxz_config.debug?console.log('全部完成'):""
            success(res)
            process(100)
          } else {
            sequentialUplode(currentChunk + 1)
          }

        } else {
          console.log('res.msg',res.msg)
        }

      }).catch((e) => {
        error && error(e)
      })
    }
  }

  /***
   * 并发上传
   **/
  const concurrentUpload = () => {
    for (var i = 0; i < chunkCount; i++) {
      let index = Number(i) + 1
      if (uploaded.indexOf(index) === -1) {
        chunkList.push(Number(i))
      }
    }
    concurrentExecution(chunkList, concurrent, (curItem) => {
      return new Promise((resolve, reject) => {
        const {
          chunk
        } = getChunkInfo(file, curItem, chunkSize)
        let chunkInfo = {
          chunk,
          currentChunk: curItem,
          chunkCount
        }
        var sd = parseInt((chunkInfo.currentChunk / chunkInfo.chunkCount) * 100)
        process(sd)
        yxz_config.debug?console.log('当前上传分片：' + curItem):""
        let inde = chunkInfo.currentChunk + 1
        if (uploaded.indexOf(inde) == -1) {
          // 构建上传文件的formData
          let uploadData = createUploadData(chunkInfo)
          uploadPost(uploadData).then(res => {
            if (res.code == 200) {
              uploaded.push(chunkInfo.currentChunk + 1)
              yxz_config.debug?console.log('已经上传完成的分片：' + uploaded):""
              // 判断是否全部上传完
              if (uploaded.length == chunkInfo.chunkCount) {
                console.log("全部上传");
                success(res)
                process(100)
              }
              resolve()
            } else {
              reject(res)
              // console.log(res.msg)
            }

          }).catch((e) => {
            console.log('erere', e)
            reject(e)
            error && error(e)
          })
        } else {
          yxz_config.debug?console.log('分片【' + chunkInfo.currentChunk + '】已上传'):''
          resolve()
        }
      })
    }).then(res => {
      console.log('finish', res)
    })
  }

  /***
   * 创建文件上传参数
   **/
  const createUploadData = (chunkInfo) => {
    let fetchForm = new FormData()
    fetchForm.append('identifier', fileMD5)
    fetchForm.append('chunkNumber', chunkInfo.currentChunk + 1)
    fetchForm.append('chunkSize', chunkSize)
    fetchForm.append('currentChunkSize', chunkInfo.chunk.size)
    const chunkfile = new File([chunkInfo.chunk], file.name)
    fetchForm.append('file', chunkfile)
    fetchForm.append('fileName', file.name)
    fetchForm.append('relativePath', file.name)
    fetchForm.append('totalChunks', chunkInfo.chunkCount)
    fetchForm.append('totalSize', file.size)
    fetchForm.append('fileType', fileType)
    fetchForm.append('objectType', objectType)
    fetchForm.append('objectTag', objectTag)
    fetchForm.append('uploadId', uploadId)
    return fetchForm
  }

  const api = axios.create({
    timeout: 100000,
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: 'Bearer ' + getStore('token')
    }
  })

  const uploadPost = (data) => api({
    url: 'api/user/uploadChunk',
    method: 'post',
    data: data
  }).then(res => {
    return res.data
  })
  // const uploadPost = (data) => api({
  //   url: '/user/uploadChunk',
  //   method: 'post',
  //   data: data
  // }).then(res => {
  //   return res.data
  // })

  readFileMD5() // 开始执行代码
}



//////////////////
// WEBPACK FOOTER
// ./common/upload.js
// module id = 13
// module chunks = 0